import React, { useEffect, useState } from "react";
import { Route, withRouter } from "react-router-dom";
// firebase
import { withFirebase } from "../../../firebaseComponents";
// util
import compose from "../../../utils/compose";

function AdminRoute(props) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    return props.firebase.auth.onAuthStateChanged((currentUser) => {
      if (currentUser) return setUser(currentUser);
      setUser(null);
      props.history.push("/login");
    });
  }, []);

  return user && <Route {...props} />;
}

export default compose(withRouter, withFirebase)(AdminRoute);
